import { Link } from "react-router-dom";
import { getCategory } from "@/utils/news";

interface CategoryBadgeProps {
  categoryKey: string;
  size?: "sm" | "md";
}

export default function CategoryBadge({ categoryKey, size = "sm" }: CategoryBadgeProps) {
  const category = getCategory(categoryKey);
  if (!category) return null;
  return (
    <Link
      to={`/category/${category.key}`}
      className={`inline-flex cursor-pointer items-center whitespace-nowrap rounded-full bg-secondary-100 font-medium text-secondary-900 transition-colors hover:bg-secondary-200 ${
        size === "sm" ? "px-2.5 py-0.5 text-xs" : "px-3 py-1 text-sm"
      }`}
    >
      {category.name}
    </Link>
  );
}